import CreateCustomSelect from "./modules/custom-select";
import "./modules/global";

const eldersHidden = document.querySelector("#elders-hidden");
const childrenHidden = document.querySelector("#children-hidden");
const eldersMinusButton = document.querySelector(".elders-choose .minus");
const eldersPlusButton = document.querySelector(".elders-choose .plus");
const eldersNumber = document.querySelector(".elders-choose .number");
const childrenMinusButton = document.querySelector(".children-choose .minus");
const childrenPlusButton = document.querySelector(".children-choose .plus");
const childrenNumber = document.querySelector(".children-choose .number");

window.addEventListener("load", () => {

	$( function() {
		$( "#datepicker" ).datepicker({ 
		  minDate: 0,
		  onSelect: function(selectedDate) {
			  $("#datepicker1").datepicker("option", "minDate", selectedDate);
		  }
		});
	  });

	  $( function() {
		$( "#datepicker1" ).datepicker({ minDate: 0 });
	  });

	$(document).ready(function() {
			$("#datepicker1").datepicker("disable");
	});

	$("#datepicker").on("click", function() {
		$("#datepicker1").datepicker("enable");
	});


	new CreateCustomSelect("#advisor-picker");
	new CreateCustomSelect("#destination-picker");
	new CreateCustomSelect("#service-picker");
	new CreateCustomSelect("#budget-picker");


	const form = document.querySelector('.wpcf7-form');
    const send_query_btn = form.querySelector('.wpcf7-submit');
                
    const destination_picker = document.querySelector('.wpcf7-form #destination-picker');
	const destination_btn = form.querySelector('.destination');

	let picked;
	destination_picker.addEventListener('change', () => {
		picked = destination_picker.options[destination_picker.selectedIndex].dataset.url;
		destination_btn.setAttribute('href', picked);
	})

	let destination_option = destination_picker.options[destination_picker.selectedIndex];

	document.addEventListener('wpcf7mailsent', function(event) {
	destination_btn.style.display = 'inline-flex';

	}, false);
            

	eldersPlusButton.addEventListener("click", (e) => {
		let i = eldersNumber.innerHTML;
		eldersNumber.textContent = ++i;
		eldersHidden.value = parseInt(eldersHidden.value) + 1;
	});
	eldersMinusButton.addEventListener("click", (e) => {
		let i = eldersNumber.innerHTML;
		if (i > 1) {
			eldersHidden.value = parseInt(eldersHidden.value) - 1;
			eldersNumber.textContent = --i;
		}
	});

	childrenPlusButton.addEventListener("click", (e) => {
		let i = childrenNumber.innerHTML;
		childrenNumber.textContent = ++i;
		childrenHidden.value = parseInt(childrenHidden.value) + 1;
	});
	childrenMinusButton.addEventListener("click", (e) => {
		let i = childrenNumber.innerHTML;
		if (i > 0) {
			childrenHidden.value = parseInt(childrenHidden.value) - 1;
			childrenNumber.textContent = --i;
		}
	});

	const hidden_name = document.querySelector(
		".form-content #advisor_name_hidden"
	);
	const advisor_name_picker = document.querySelector(
		".form-content .wpcf7-form-control-wrap select"
	);

	advisor_name_picker.addEventListener("change", (e) => {
		const advisor_name = document.querySelector(
			"#select-advisor-picker .option--selected"
		).textContent;

		hidden_name.value = advisor_name;
	});

	$(function () {
		$("#datepicker").datepicker({
			dayNamesMin: ["Pon", "Uto", "Sre", "Cet", "Pet", "Sub", "Ned"],

			monthNames: [
				"Januar",
				"Februar",
				"Mart",
				"April",
				"Maj",
				"Jun",
				"Jul",
				"Avgust",
				"Septembar",
				"Oktobar",
				"Novembar",
				"Decembar",
			],
		});
		$("#datepicker").datepicker("option", "dateFormat", "dd.mm.yy");
	});

	$(function () {
		$("#datepicker1").datepicker({
			dayNamesMin: ["Pon", "Uto", "Sre", "Cet", "Pet", "Sub", "Ned"],
			monthNames: [
				"Januar",
				"Februar",
				"Mart",
				"April",
				"Maj",
				"Jun",
				"Jul",
				"Avgust",
				"Septembar",
				"Oktobar",
				"Novembar",
				"Decembar",
			],
		});
		$("#datepicker1").datepicker("option", "dateFormat", "dd.mm.yy");
	});

	
});
